import axios from "axios";
import {
  GET_LIMITED_ANNOUNCEMENT_REQUEST,
  GET_LIMITED_ANNOUNCEMENT_SUCCESS,
  GET_LIMITED_ANNOUNCEMENT_FAIL,
} from "../../types/admin/limitedAnnouncementTypes";

export const getLimitedAnnouncementAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: GET_LIMITED_ANNOUNCEMENT_REQUEST,
      });

      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth-dashboard/lim-announcements/`,
        config
      );
      dispatch({
        type: GET_LIMITED_ANNOUNCEMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);

      if (!err) {
        err = "Network Error";
      }

      dispatch({
        type: GET_LIMITED_ANNOUNCEMENT_FAIL,
        payload: err,
      });

      throw err;
    }
  };
